module.exports = __webpack_public_path__ + "img/ic-arrow-right-white.2dd28f03.svg";